/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { AuthClient, AuthClient$inboundSchema } from "./authclient.js";

/**
 * configured when authentication is required and at least one enabled client is offered; setup_incomplete when it is required and none is; no_auth_required when the upstream explicitly needs none; undecided when nobody has said.
 */
export const McpServerAuthenticationStatus = {
  Configured: "configured",
  SetupIncomplete: "setup_incomplete",
  NoAuthRequired: "no_auth_required",
  Undecided: "undecided",
} as const;
/**
 * configured when authentication is required and at least one enabled client is offered; setup_incomplete when it is required and none is; no_auth_required when the upstream explicitly needs none; undecided when nobody has said.
 */
export type McpServerAuthenticationStatus = OpenEnum<
  typeof McpServerAuthenticationStatus
>;

/**
 * How an MCP server authenticates to its upstream.
 */
export type McpServerAuthentication = {
  /**
   * The auth clients the server offers.
   */
  clients: Array<AuthClient>;
  /**
   * The MCP server id.
   */
  mcpServerId: string;
  /**
   * The MCP server's project.
   */
  projectId: string;
  /**
   * Whether the MCP server is public.
   */
  public: boolean;
  /**
   * Whether the upstream needs authentication. Omitted while undecided.
   */
  requiresUpstreamAuth?: boolean | undefined;
  /**
   * configured when authentication is required and at least one enabled client is offered; setup_incomplete when it is required and none is; no_auth_required when the upstream explicitly needs none; undecided when nobody has said.
   */
  status: McpServerAuthenticationStatus;
};

/** @internal */
export const McpServerAuthenticationStatus$inboundSchema: z.ZodMiniType<
  McpServerAuthenticationStatus,
  unknown
> = openEnums.inboundSchema(McpServerAuthenticationStatus);

/** @internal */
export const McpServerAuthentication$inboundSchema: z.ZodMiniType<
  McpServerAuthentication,
  unknown
> = z.pipe(
  z.object({
    clients: z.array(AuthClient$inboundSchema),
    mcp_server_id: z.string(),
    project_id: z.string(),
    public: z.boolean(),
    requires_upstream_auth: z.optional(z.boolean()),
    status: McpServerAuthenticationStatus$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "mcp_server_id": "mcpServerId",
      "project_id": "projectId",
      "requires_upstream_auth": "requiresUpstreamAuth",
    });
  }),
);

export function mcpServerAuthenticationFromJSON(
  jsonString: string,
): SafeParseResult<McpServerAuthentication, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => McpServerAuthentication$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'McpServerAuthentication' from JSON`,
  );
}
